import React, { useEffect } from 'react';

import { InspectorFormProvider, LogDataFormGroup } from '../../../components';
import { useAccordionContext } from '../../../contexts';
import { DocumentInspectorProps } from '../../../types';
import { createId } from '../../../utils';
import { AccordionButtonProps } from './AccordionButton';

export function AccordionButtonInspector({
  value,
  onChange,
}: DocumentInspectorProps<AccordionButtonProps>) {
  return (
    <InspectorFormProvider value={value} onChange={onChange}>
      <AccordionButtonInspectorFields value={value} onChange={onChange} />
    </InspectorFormProvider>
  );
}

function AccordionButtonInspectorFields({
  value,
  onChange,
}: DocumentInspectorProps<AccordionButtonProps>) {
  const { setLogData } = useAccordionContext();
  const { children, ...others } = value ?? {};

  useEffect(() => {
    if (value?.key == null) {
      onChange({
        ...value,
        key: createId(),
      });
    }
  }, []);

  return (
    <LogDataFormGroup
      nodeKey={value?.key}
      {...setLogData?.(others)}
    />
  );
}
